import * as Tone from "tone";

class Soundscapes {
    constructor() {
        this.soundScapePlayer = null;
        this.playWhenLoaded = false;
    }

    stop() {
        this.playWhenLoaded = false;
        if (this.soundScapePlayer) {
            this.soundScapePlayer.dispose();
        }
        this.soundScapePlayer = null;
    }

    pause() {
        this.playWhenLoaded = false;
        if (this.soundScapePlayer && this.soundScapePlayer.state == "started") {
            this.soundScapePlayer.stop();
        }
    }

    resume() {
        if (this.soundScapePlayer && this.soundScapePlayer.loaded && this.soundScapePlayer.state != "started") {
            this.soundScapePlayer.start();
        } else if (this.soundScapePlayer && !this.soundScapePlayer.loaded) {
            this.playWhenLoaded = true;
        }
    }

    onLoopLoaded() {
        if (this.playWhenLoaded) {
            this.resume();
        }
    }

    load(atmosphereSoundtrack) {
        this.stop();
        if (atmosphereSoundtrack) {
            this.soundScapePlayer = new Tone.Player({
                url: atmosphereSoundtrack,
                loop: true,
                autostart: false,
                onload: this.onLoopLoaded.bind(this)
            }).toDestination();
        }
    }
}

export { Soundscapes }

